import React, { useState } from "react";
import { Upload, CheckCircle, AlertCircle, FileText, Calendar, Hash } from "lucide-react";

export default function ChallanUpload() {
  const [formData, setFormData] = useState({
    transactionId: "",
    paymentDate: "",
    amount: "",
    file: null
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({ ...prev, file: e.target.files[0] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // Simulate upload
    setTimeout(() => {
      setLoading(false);
      setSuccess(true);
      alert("चलन यशस्वीपणे अपलोड झाले! (Challan uploaded successfully!)");
    }, 2000);
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gray-50 p-6 flex items-center justify-center">
        <div className="bg-white p-10 rounded-2xl shadow-xl border border-green-100 text-center max-w-md">
          <div className="bg-green-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 text-green-600">
            <CheckCircle size={48} />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">अभिनंदन!</h2>
          <p className="text-gray-600 mb-8">तुमचे चलन यशस्वीपणे सबमिट झाले आहे. पडताळणीसाठी काही वेळ प्रतीक्षा करा.</p>
          <button 
            onClick={() => setSuccess(false)}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-xl transition shadow-lg"
          >
            दुसरे चलन अपलोड करा
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-900 to-indigo-900 p-8 text-white">
            <h2 className="text-3xl font-bold mb-2">भरलेले चलन अपलोड करा</h2>
            <p className="text-blue-100 opacity-90">Upload Paid Registration Challan</p>
          </div>

          <form onSubmit={handleSubmit} className="p-8">
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              {/* Payment Details */}
              <div className="space-y-5">
                <h4 className="font-bold text-gray-900 border-b pb-2 flex items-center gap-2">
                  <FileText size={18} className="text-blue-600" />
                  पेमेंट तपशील
                </h4>
                
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">ट्रांझॅक्शन आयडी (Transaction ID) *</label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                      <Hash size={16} />
                    </span>
                    <input
                      type="text"
                      name="transactionId"
                      required
                      placeholder="Enter Transaction ID"
                      value={formData.transactionId}
                      onChange={handleInputChange}
                      className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition outline-none"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">पेमेंट तारीख (Payment Date) *</label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                      <Calendar size={16} />
                    </span>
                    <input
                      type="date"
                      name="paymentDate"
                      required
                      value={formData.paymentDate}
                      onChange={handleInputChange}
                      className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition outline-none"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">भरलेली रक्कम (Amount Paid) *</label>
                  <div className="relative font-bold">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-blue-600">₹</span>
                    <input
                      type="number"
                      name="amount"
                      required
                      placeholder="0.00"
                      value={formData.amount}
                      onChange={handleInputChange}
                      className="w-full pl-8 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition outline-none"
                    />
                  </div>
                </div>
              </div>

              {/* File Upload */}
              <div className="space-y-5">
                <h4 className="font-bold text-gray-900 border-b pb-2 flex items-center gap-2">
                  <Upload size={18} className="text-blue-600" />
                  फाइल अपलोड
                </h4>
                
                <div className="relative group">
                  <input
                    type="file"
                    required
                    onChange={handleFileChange}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                    accept=".pdf,.jpg,.jpeg,.png"
                  />
                  <div className={`p-8 border-2 border-dashed rounded-2xl text-center transition ${formData.file ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-gray-50 group-hover:bg-gray-100'}`}>
                    <div className="bg-white w-16 h-16 rounded-full shadow-sm flex items-center justify-center mx-auto mb-4 text-blue-600">
                      <Upload size={28} />
                    </div>
                    {formData.file ? (
                      <div className="text-blue-600">
                        <p className="font-bold truncate max-w-xs mx-auto">{formData.file.name}</p>
                        <p className="text-xs opacity-75">Click to change file</p>
                      </div>
                    ) : (
                      <>
                        <p className="font-bold text-gray-800">चलनाची स्कॅन कॉपी निवडा</p>
                        <p className="text-xs text-gray-500 mt-1">PDF, JPG, PNG (Max 5MB)</p>
                      </>
                    )}
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 p-4 rounded-xl flex gap-3 text-amber-900 italic text-sm">
                  <AlertCircle size={20} className="flex-shrink-0" />
                  <p>कृपया खात्री करा की पावती स्पष्ट आहे आणि त्यावरील शिक्का आणि दिनांक दिसत आहे.</p>
                </div>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full flex items-center justify-center gap-2 ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-900 hover:bg-indigo-900'} text-white font-bold py-4 rounded-xl transition shadow-lg transform active:scale-95`}
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  अपलोड होत आहे...
                </>
              ) : (
                <>
                  सबमिट करा (Confirm & Upload)
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
